export default __webpack_public_path__ + "static/media/analyticsIcon.d52ef60b.svg";